<!-- Zone de saisie et filtre de recherche -->
<div class="space-y-3.5">
  @if (internalPreferredCities().length < 5) {
    <div class="space-y-2">
      <span class="text-xs font-bold text-neutral-12 uppercase tracking-wider flex items-center gap-2">
        <span
          class="w-5 h-5 rounded-full bg-primary-2 text-primary-11 text-[11px] font-mono font-bold flex items-center justify-center"
        >
          <mat-icon class="w-3! h-3! text-xs!">search</mat-icon>
        </span>
        Ajouter une commune d'alerte
      </span>

      <!-- Champ de recherche de commune -->
      <mat-form-field appearance="outline" class="w-full" subscriptSizing="dynamic">
        <input
          aria-label="Rechercher une commune par nom ou code postal"
          matInput
          placeholder="Nom de la commune ou code postal (ex : Auch, 32000...)"
          [value]="citySearchQuery()"
          (input)="onCitySearchInput($any($event.target).value)"
          [matAutocomplete]="cityAuto"
        />
        <mat-icon matPrefix class="mr-3 text-neutral-8">location_city</mat-icon>

        @if (isSearchingCity()) {
          <mat-progress-spinner
            matSuffix
            mode="indeterminate"
            diameter="18"
            class="mr-2"
          ></mat-progress-spinner>
        } @else if (citySearchQuery()) {
          <button
            mat-icon-button
            matSuffix
            type="button"
            class="text-neutral-9 mr-1"
            (click)="onCitySearchInput('')"
            title="Effacer"
          >
            <mat-icon class="w-4! h-4! text-base!">close</mat-icon>
          </button>
        }

        <mat-autocomplete
          #cityAuto="matAutocomplete"
          (optionSelected)="addPreferredCity($event.option.value)"
        >
          @for (city of citySuggestions(); track city.name + '-' + city.zipCode) {
            <mat-option [value]="city">
              <div class="flex items-center gap-2.5 py-1">
                <div
                  class="w-6 h-6 rounded-lg bg-primary-2 text-primary-11 flex items-center justify-center shrink-0"
                >
                  <mat-icon class="w-3.5! h-3.5! text-sm!">place</mat-icon>
                </div>
                <span class="font-bold text-xs text-neutral-12">{{ city.name }}</span>
                <span class="text-xs text-neutral-10 font-mono">({{ city.zipCode }})</span>
                <span
                  class="text-[10px] text-neutral-9 dark:text-neutral-11 font-semibold ml-auto font-mono px-2 py-0.5 rounded bg-neutral-2 dark:bg-neutral-3 border border-neutral-3 dark:border-neutral-4"
                >
                  Dép. {{ city.departmentCode }}
                </span>
              </div>
            </mat-option>
          }
        </mat-autocomplete>
      </mat-form-field>
    </div>

    @if (selectedDepartmentsSummary()) {
      <!-- Bannière informative sur le périmètre de filtrage -->
      <div
        class="flex items-center justify-between gap-3 px-3.5 py-2.5 bg-neutral-2/70 dark:bg-neutral-3/70 rounded-xl border border-neutral-3 dark:border-neutral-4 text-xs"
      >
        <span class="flex items-center gap-2 text-neutral-11">
          <mat-icon class="w-4! h-4! text-base! text-primary-9 shrink-0">filter_alt</mat-icon>
          <span>
            Résultats restreints à vos départements couverts :
            <strong class="text-neutral-12 font-bold">{{ selectedDepartmentsSummary() }}</strong>
          </span>
        </span>
        @if (uncoveredResultsCount() > 0) {
          <span class="text-[11px] text-neutral-9 italic shrink-0">
            {{ uncoveredResultsCount() }} résultat(s) hors secteur masqué(s)
          </span>
        }
      </div>
    }
  } @else {
    <!-- Message si quota maximum de 5 villes atteint -->
    <div class="p-4 bg-primary-2 rounded-xl border border-primary-4 flex items-center gap-3">
      <mat-icon class="text-primary-11 shrink-0 w-5! h-5! text-xl!">check_circle</mat-icon>
      <div class="flex-1">
        <p class="text-xs font-bold text-primary-11">Limite maximale atteinte (5/5 communes)</p>
        <p class="text-xs text-primary-10 mt-0.5">
          Vous avez configuré vos 5 communes prioritaires. Vous pouvez en retirer une ci-dessous pour en
          sélectionner une autre.
        </p>
      </div>
    </div>
  }

  <!-- Liste des villes configurées -->
  @if (internalPreferredCities().length > 0) {
    <div class="space-y-3 pt-3 border-t border-neutral-3 dark:border-neutral-4">
      <div class="flex items-center justify-between">
        <span class="text-xs font-bold text-neutral-12 uppercase tracking-wider flex items-center gap-2">
          Communes configurées pour vos alertes ({{ internalPreferredCities().length }}/5) :
        </span>
        <span class="text-[11px] text-primary-11 font-semibold flex items-center gap-1">
          <mat-icon class="w-3.5! h-3.5! text-xs!">bolt</mat-icon>
          Alertes email en temps réel
        </span>
      </div>

      <div class="flex flex-wrap gap-2.5">
        @for (city of internalPreferredCities(); track city.name + '-' + city.zipCode) {
          <div
            class="inline-flex items-center gap-2.5 px-3.5 py-2 rounded-xl text-xs font-semibold bg-white dark:bg-neutral-2 text-neutral-12 border border-primary-4 shadow-xs hover:border-primary-6 transition-all group"
          >
            <div
              class="w-6 h-6 rounded-lg bg-primary-2 text-primary-11 flex items-center justify-center shrink-0"
            >
              <mat-icon class="w-3.5! h-3.5! text-sm!">mark_email_unread</mat-icon>
            </div>
            <span class="font-bold text-neutral-12">{{ city.name }}</span>
            <span class="font-mono text-neutral-10 text-[11px]">({{ city.zipCode }})</span>
            <span
              class="text-[10px] font-mono px-2 py-0.5 rounded bg-neutral-2 dark:bg-neutral-3 text-neutral-9 dark:text-neutral-11 font-semibold border border-neutral-3 dark:border-neutral-4"
            >
              Dép. {{ city.departmentCode }}
            </span>
            <button
              type="button"
              class="hover:text-error-9 text-neutral-7 hover:bg-error-2 rounded-lg p-1 transition-colors cursor-pointer flex items-center justify-center ml-1"
              (click)="removePreferredCity(city)"
              title="Retirer cette commune"
            >
              <mat-icon class="w-3.5! h-3.5! text-sm!">close</mat-icon>
            </button>
          </div>
        }
      </div>
    </div>
  } @else {
    <div class="p-6 text-center border-2 border-dashed border-neutral-3 rounded-2xl bg-neutral-1">
      <p class="text-xs text-neutral-10 italic">
        Aucune commune d'alerte configurée pour le moment. Vous recevrez les alertes de tout votre secteur
        d'intervention.
      </p>
    </div>
  }
</div>
